module.exports = __webpack_public_path__ + "img/xiaoxin_20210901114630.60594ce1.png";